export default (startingTab = 1) => ({

    selectedId: null,

    init() {
        this.$nextTick(() => this.select(this.$id('tab', startingTab)));
    },

    select(id) {
        this.selectedId = id;
    },

    isSelected(id) {
        return this.selectedId === id;
    },

    whichChild(el, parent) {
        return Array.from(parent.children).indexOf(el) + 1;
    },

    tabs: {
        ['x-id']() {
            return ['tab'];
        },
    },

    tablist: {
        ['x-ref']: 'tablist',
        ['x-on:keydown.right.prevent.stop']() {
            return this.$focus.wrap().next();
        },
        ['x-on:keydown.home.prevent.stop']() {
            return this.$focus.first();
        },
        ['x-on:keydown.page-up.prevent.stop']() {
            return this.$focus.first();
        },
        ['x-on:keydown.left.prevent.stop']() {
            return this.$focus.wrap().prev();
        },
        ['x-on:keydown.end.prevent.stop']() {
            return this.$focus.last();
        },
        ['x-on:keydown.page-down.prevent.stop']() {
            return this.$focus.last();
        },
        ['role']: 'tablist',
    },

    tab: {
        ['x-bind:id']() {
            return this.$id('tab', this.whichChild(this.$el, this.$refs.tablist));
        },
        ['x-on:click']() {
            this.select(this.$el.id);
        },
        ['x-on:focus']() {
            this.select(this.$el.id);
        },
        ['x-bind:tabindex']() {
            return this.isSelected(this.$el.id) ? 0 : -1;
        },
        ['x-bind:aria-selected']() {
            return this.isSelected(this.$el.id);
        },
        ['role']: 'tab',
    },

    tabpanels: {
        ['role']: 'tabpanel',
    },

    tabpanel: {
        ['x-show']() {
            return this.isSelected(this.$id('tab', this.whichChild(this.$el, this.$el.parentElement)));
        },
        ['x-bind:aria-labelledby']() {
            return this.$id('tab', this.whichChild(this.$el, this.$el.parentElement));
        },
        ['role']: 'tabpanel',
    },

    namedTab: (name) => ({
        ['x-bind:id']() {
            return this.$id('tab', name);
        },
        ['x-on:click']() {
            this.select(this.$el.id);
        },
        ['x-on:focus']() {
            this.select(this.$el.id);
        },
        ['x-bind:tabindex']() {
            return this.isSelected(this.$el.id) ? 0 : -1;
        },
        ['x-bind:aria-selected']() {
            return this.isSelected(this.$el.id);
        },
        ['role']: 'tab',
    }),

    namedTabpanel: (name) => ({
        ['x-show']() {
            return this.isSelected(this.$id('tab', name));
        },
        ['x-bind:aria-labelledby']() {
            return this.$id('tab', name);
        },
        ['role']: 'tabpanel',
    }),
})
